import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mi-support" }

import { computed, onMounted, ref } from 'vue';

import { MI_IT_ORIGIN } from './constants';
import HeadsetIcon from './HeadsetIcon.vue';
import SupportOverlay from './SupportOverlay.vue';
import { useSupportButton } from './useSupportButton';
import { useUserName } from './useUserName';
import { buildSupportQueryParams } from './utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const visible = ref(false);

const userName = useUserName();

const baseQueryParams = computed(() =>
  userName.value ? buildSupportQueryParams(userName.value) : ''
);

const iframeSrc = computed(() => {
  if (!baseQueryParams.value) return '';
  return `https://${MI_IT_ORIGIN}/feedback?${baseQueryParams.value}`;
});

const { position, isDragging, isReady, onMouseDown, initPosition } = useSupportButton(() => {
  visible.value = !visible.value;
});

const isButtonReady = computed(() => isReady.value && !!userName.value);

onMounted(() => {
  initPosition();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SupportOverlay, {
      visible: visible.value,
      "user-name": _unref(userName),
      "iframe-src": iframeSrc.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
    }, null, 8, ["visible", "user-name", "iframe-src"]),
    (isButtonReady.value)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          id: "rms-it__helper",
          class: _normalizeClass(["support-button", { 'is-dragging': _unref(isDragging) }]),
          style: _normalizeStyle({ right: `${_unref(position).x}px`, bottom: `${_unref(position).y}px` }),
          onMousedown: _unref(onMouseDown)
        }, {
          default: _withCtx(() => [
            _createVNode(HeadsetIcon, { size: 24 })
          ]),
          _: 1
        }, 8, ["class", "style", "onMousedown"]))
      : _createCommentVNode("", true)
  ]))
}
}

})